// extracted by mini-css-extract-plugin
export default {"photo":"PlayerImage_photo__qHomn","lgPhoto":"PlayerImage_lgPhoto__PoEAB","smPhoto":"PlayerImage_smPhoto__BeVdO"};